import { appActions } from 'app/app.actions';
import { createCommands, useCommandHandler } from 'utils/commands';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { pubSub } from 'utils/pubSub';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

export const searchCommands = createCommands([
  {
    group: 'search',
    label: 'Open search input',
    name: 'openSearchInput',
    description: 'Opens the search input in the top bar',
    keyboard: { keybindings: [{ binding: [[], 'Slash'] }] },
    useRegisterHandler: () => {
      const flags = useFeatureFlag(['new-topbar']);
      const dispatch = useAppDispatch();

      useCommandHandler({
        name: 'search:openSearchInput',
        actionFn: () => {
          if (flags.newTopbar) {
            dispatch(
              appActions.showModal({ modal: { type: 'app:commandLauncher' } }),
            );
          } else {
            pubSub.publish('toggleGlobalSearch', { isOpen: true });
          }
        },
      });
    },
  },
]);
